import { render, staticRenderFns } from "./LayoutAside.vue?vue&type=template&id=4b7f6bf2&scoped=true"
import script from "./LayoutAside.vue?vue&type=script&lang=js"
export * from "./LayoutAside.vue?vue&type=script&lang=js"
import style0 from "./LayoutAside.vue?vue&type=style&index=0&id=4b7f6bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f6bf2",
  null
  
)

export default component.exports